<template>
  <v-container class="pt-0 px-0">
    <v-subheader class="text-h5 px-0">NFC-Tag schreiben
        <v-spacer></v-spacer>
        <v-btn class="mx-0" small fab dark :color="scanner_enabled ? 'secondary' : 'primary'" @click="initReaders">
            <v-icon dark>{{ scanner_enabled ? 'mdi-barcode-off' : 'mdi-barcode' }} </v-icon>
        </v-btn>
    </v-subheader>
    <v-text-field class="mb-2" label="Wert welcher auf den NFC-Tag geschrieben werden soll" v-model="write" required color="white" dense hide-details="auto" outlined autocomplete="false"></v-text-field>
    <v-alert dense :type="msg_type">{{ msg }}</v-alert>
    <v-btn class="mx-0 mb-10" block dark color="primary" :disabled="String(write).length==0" @click="writeToTag">Auf NFC-Tag schreiben</v-btn>
    <StreamBarcodeReader v-if="scanner_enabled" @decode="onDecode" @loaded="onLoaded"></StreamBarcodeReader>
    <v-snackbar v-model="snackbar" :color="snackbar_color" timeout="5000" bottom class="snackbar text-center">{{ snackbar_text }}</v-snackbar>
  </v-container>
</template>

<script>
/* global NDEFReader */
import StreamBarcodeReader from "@/components/BarcodeScanner.vue";
import beep from '@/mixins/beep';
import scanner from '@/mixins/scanner';
import emitter from '@/eventBus.js';

  export default {
    name: 'NFCWriterComp',
    components:{
        StreamBarcodeReader
    },
    mixins: [beep,scanner],
    data: () => ({
        settings:{},
        write:"",
        msg: "Geben sie den zu schreibenden Text ein",
        msg_type: "info",
        snackbar: false,
        snackbar_color: "success",
        snackbar_text: "Speichern erfolgreich",
        scanner_enabled: false,
        prev_scan: '',
        num_same_scans: 0,
    }),
    created() {
        emitter.on('nfc-read', this.handleNFC);
    },
    beforeDestroy() {
        emitter.off('nfc-read', this.handleNFC);
    },
    mounted(){
        var s = localStorage.getItem("settings")
        if (s) this.settings =  JSON.parse(s);
        this.settings.barcodepruefung = this.settings.barcodepruefung || 2;

        //  Barcodescanner
        if (this.scanner){
            this.scanner.setScannerMode(scanner.SCANNER_MODE_TIME);
            this.scanner.on("scan", this.onScan);
        }
    },
    methods: {
        initReaders(){
            this.scanner_enabled = !this.scanner_enabled
        },
        onScan(scandata){
            this.write = scandata
        },
        async writeToTag(){
            this.msg = "Schreibe ...."
            this.msg_type = "info"
            if (!('NDEFReader' in window)) {
                this.snackbar_text = "NFC schreiben wird von diesem Gerät nicht unterstützt"
                this.snackbar_color = "red"
                this.snackbar = true
                return;
            }
            const textToWrite = this.write.trim();
            if (!textToWrite) {
                this.snackbar_text = "Bitte einen Text eingeben, um auf das Tag zu schreiben"
                this.snackbar_color = "red"
                this.snackbar = true
                return;
            }

            try {
                emitter.emit('nfc-stop')
                this.msg = "Bitte halten Sie ein beschreibbares NFC-Tag ans Gerät..."
                const writer = new NDEFReader();
                await writer.write({
                    records: [
                        { recordType: "text", data: textToWrite }
                    ]
                });
                this.snackbar_text = `Erfolgreich geschrieben: "${textToWrite}"`
                this.snackbar_color = "green"
                this.snackbar = true
                this.msg = "Geben sie den zu schreibenden Text ein"
                this.write = ""
            } catch (error) {
                this.snackbar_text = `Schreibfehler: ${error.message}`
                this.snackbar_color = "red"
                this.snackbar = true
                this.msg_type = "error"
                this.msg = "Starten sie den schreibvorgang erneut!"
            } finally {
                // Lese-Sitzung wieder starten, sonst werden Tags danach nicht mehr gelesen
                emitter.emit('nfc-init')
            }
        },
        onDecode (result) {
            if (result!=this.prev_scan){
                this.num_same_scans = 1;
            }else{
                this.num_same_scans++;
            }
            if (this.num_same_scans>=this.settings.barcodepruefung){
                this.scanner_enabled = false
                this.beep(1,2500,"sine",50);
                this.write = result
            }else{
                this.beep(0.5,3500,"sine",10);
            }
            this.prev_scan = result;
        },
        onLoaded () {
            console.log("loaded")
        }
    }
  }
</script>
<style scoped>
    .snackbar{
        text-align: center;
    }
</style>